import React from 'react';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';
import { Redirect } from 'react-router-dom';
import { PATH_APP } from 'src/routes/paths';
import { isAdmin } from 'src/utils/permissions';

PermissionProtect.propTypes = {
  children: PropTypes.node,
  requireIniciarFirma: PropTypes.bool,
  requireAdmin: PropTypes.bool,
};

function PermissionProtect({ children, requireIniciarFirma = false, requireAdmin = false }) {
  const { user } = useAuth();

  // Perfil aún no cargado (el estado inicial de redux no incluye tipousuario):
  // esperar sin redirigir para no expulsar a un admin durante la carga.
  if (!user || user.tipousuario === undefined) return null;

  if (requireAdmin && !isAdmin(user.tipousuario)) {
    return <Redirect to={PATH_APP.general.root} />;
  }

  if (requireIniciarFirma && !user.permiso_iniciar_firma) {
    return <Redirect to={PATH_APP.general.root} />;
  }

  return <>{children}</>;
}

export default PermissionProtect;
